import { render, staticRenderFns } from "./scoreboard_radial.vue?vue&type=template&id=438ea0e3&scoped=true&lang=html&"
import script from "./scoreboard_radial.vue?vue&type=script&lang=js&"
export * from "./scoreboard_radial.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_radial.vue?vue&type=style&index=0&id=438ea0e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ea0e3",
  null
  
)

export default component.exports